
export const FIRST_DAY = "April 04, 2023"
export const SECOND_DAY = "April 05, 2023"
export const FIRST_DATE = "2023-04-04"
export const SECOND_DATE = "2023-04-05"
